export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const FORM_VALIDATION_ERROR = 'VALIDATION';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
